module.exports = __webpack_public_path__ + "static/media/6.4703bc31.jpg";